"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRDataInjector = void 0;
const jotai_1 = require("jotai");
const utils_1 = require("jotai/utils");
const react_1 = require("react");
const react_2 = require("@remix-run/react");
const common_1 = require("./common");
/**
 * SSR + Hydration
 */
const SSRDataInjector = (props) => {
    const store = (0, jotai_1.useStore)();
    const matches = (0, react_2.useMatches)();
    const hydrateAtoms = (0, react_1.useMemo)(() => {
        const res = [];
        matches.forEach((m) => {
            const data = m.data;
            for (const key in data) {
                if (!key.startsWith('$')) {
                    continue;
                }
                const atom = (0, common_1.getAtom)(props, key);
                const atomData = data[key];
                res.push([atom, atomData]);
            }
        });
        return res;
    }, []);
    (0, utils_1.useHydrateAtoms)(hydrateAtoms, { store });
    return null;
};
exports.SSRDataInjector = SSRDataInjector;
